<!--
 * @Author: cjh
 * @LastEditors: Du Feng
 * @Date: 2022-01-11 11:38:33
 * @LastEditTime: 2022-07-05 09:34:35
 * @Description: Modify here please
-->
<template>
  <div class="detail_box">
    <div class="detail" v-show="!detail.show">
      <div class="header">
        <div class="left" @click="toIndex()">< 返回</div>
        <div class="span1">
          <span>课程详情</span>
        </div>
        <div class="right"></div>
      </div>
      <div class="info_header">
        <div class="info_header_item">
          <img :src="info.coverUrl" alt="" />
        </div>
        <div class="info_header_item">
          <div>
            <span style="margin-right: 10px;"> 课程名称: </span>
            <span> {{ info.cname || "无" }}</span>
          </div>
          <!-- <div> <span style="margin-right: 10px;"> 当前状态:</span><span> {{ stateObj[info.auditState] || "未审核"  }}</span></div> -->
          <div>
            <span style="margin-right: 10px;"> 创建时间: </span>
            <span>
              {{ dayjs(info.createTime).format("YYYY.MM.DD") || "无" }}</span
            >
          </div>
        </div>
      </div>
      <div class="main">
        <div class="main-title">
          <img src="./imgs/title-1.svg" alt="" />
          <p>课程信息</p>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="课程介绍" name="first">
            <!-- ===============课程介绍板块====================-->
            <div
              class="main-li"
              v-for="(item, i) in list"
              :key="i + item.title"
            >
              <p>{{ item.title }}</p>
              <span
                :style="{ color: item.title === '附件' ? '#4991E 1' : '' }"
                v-html="item.text"
              ></span>
            </div>
            <div class="main-li">
              <p>视频介绍</p>
              <div class="file-box">
                <span v-if="info.resource.length==0">无</span>
                <template v-for="(file, i) in info.resource">
                  <div
                    :key="i + 'files-zy'"
                    class="file-item"
                    v-if="file.source == '0'"
                  >
                    <img
                      :src="file.previewUrl"
                      alt=""
                      class="material-img"
                      v-if="getFileType(file.ext) === 'imgs'"
                    />
                    <video
                      v-else-if="getFileType(file.ext) === 'video'"
                      class="video-class"
                      :src="file.previewUrl"
                      controls
                      controlslist="nodownload"
                      :ref="'videoObj' + i"
                    ></video>
                  </div>
                </template>
              </div>
            </div>
            <!-- <div class="main-li" v-if="type !== 'school'">
              <p>课程材料</p>
              <div
                class="to_material"
                v-if="info.mid && type !== 'import'"
                @click="toMDetail"
              >
                查看材料详情
              </div>
              <div class="file-box" v-if="info.mid && type === 'import'">
                <div class="file-name">{{ m_info.describe }}</div>
                <template v-for="(file, i) in m_info.resource">
                  <div
                    :key="i + 'files'"
                    class="file-item"
                    v-if="getFileType(file.ext) === 'img'"
                  >
                    <img :src="file.previewUrl" alt="" />
                    <div style="text-align:center">{{ m_info.mname }}</div>
                  </div>
                </template>
              </div>
            </div> -->
          </el-tab-pane>
           <el-tab-pane v-if="info.mid" label="材料管理" name="material">
                  <mtDetail
                  :info.sync="mtDetail.info"
                ></mtDetail>
          </el-tab-pane>
          <el-tab-pane v-if="type !== 'school'" label="教案课件" name="second">
            <!-- ===============教案课件板块====================-->
            <div class="main-title" style="margin-top: 30px">
              <img src="./imgs/title-2.svg" alt="" />
              <p>教案简案及详案</p>
            </div>
            <ul class="table">
              <div class="table-header">
                <div style="width: 15%">课时</div>
                <div style="width: 35%">教案</div>
                <div style="width: 15%">课时</div>
                <div style="width: 35%">教案</div>
              </div>
              <li v-for="(item, i) in table_1" :key="i + item.id">
                <div class="td-1">{{ i + 1 }}</div>
                <div class="td-2">
                  <div class="file">
                    <div>
                      <img src="./imgs/file-icon.svg" alt="" />
                      <span>{{ item.name || "无" }}</span>
                    </div>
                    <a href="javascript:;" @click="previewFile(item)">预览</a>
                  </div>
                </div>
              </li>
            </ul>

            <div class="main-title" style="margin-top: 50px">
              <img src="./imgs/title-3.svg" alt="" />
              <p>授课课件示例</p>
            </div>
            <div class="table" style="width: 50%">
              <div
                v-for="(item, i) in table_2"
                :key="item.id + i"
                class="table_2_tr"
              >
                <div class="td-1">示例课件{{ i + 1 || "无" }}</div>
                <div class="td-2">
                  <div class="file">
                    <div>
                      <img src="./imgs/file-icon.svg" alt="" />
                      <span>{{ item.name || "无" }}</span>
                    </div>
                    <a href="javascript:;" @click="previewFile(item)">预览</a>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane v-if="type !== 'school'" label="审核记录" name="three">
            <div class="main-title" style="margin-top: 20px">
              <img src="./imgs/title-4.svg" alt="" />
              <p>审核记录</p>
            </div>
            <!-- 课程审核-详情 -->
            <div>
              <div class="handle">
                <div
                  v-for="(item, i) in detail.info.operateList"
                  :key="i + '审核记录'"
                  class="handle-item"
                >
                  <img
                    src="./imgs/reject.svg"
                    alt=""
                    v-if="item.auditState === '3'"
                  />
                  <img src="./imgs/pass.svg" alt="" v-else />
                  <div class="handle-title">
                    <p v-if="item.auditState">
                      {{ stateObj[item.auditState] }}
                    </p>
                    <!-- <p class="text">{{ item.operateOpinion }}</p> -->
                  </div>
                  <span class="handle-name">{{
                    item.operateOrgName || item.operateName
                  }}</span>
                  <span class="handle-time">{{
                    dayjs(item.operateTime).format("YYYY.MM.DD  h:mm")
                  }}</span>
                  <div
                    class="line"
                    v-if="i < item.operateOrgName.length - 1"
                  ></div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <!-- 引入课程 -->
        <template v-if="type === 'import' && importAuditState === '1'">
          <div class="import_footer">
            <el-button
              style="margin-right: 20px; width: 150px"
              :disabled="!import_agreed"
              type="primary"
              size="small"
              @click="importFun()"
              >引入</el-button
            >
            <el-button style="width: 150px" size="small" @click="toIndex()"
              >取消</el-button
            >
          </div>
          <div class="import_checkbox">
            <el-checkbox v-model="import_agreed"
              >我已详细审阅以上课程内容和关联材料内容，确认该课程和关联材料的所有内容均合法合规，确定引入到{{
                Userlist.last_top_org_name
              }}</el-checkbox
            >
          </div>
        </template>
      </div>
    </div>
    <!-- <mDetail
      :info.sync="detail.info"
      v-show="detail.show"
      @to-index="toDetail"
    ></mDetail> -->
  </div>
</template>
<script>
import educationApi from "@/api/education/index.js";
import dayjs from "dayjs";
import util from "@/utils/util.js";
// import mDetail from "@/views/school/courseManager/materialManger/detail.vue";
import mtDetail from "@/views/mechanism/supervise/materialDetail.vue";
import {
  handleMaterialsDetail,
  getAuditrecordList,
} from "@/api/mechanismApi/curriculum.js";
import schoolApi from "@/api/schoolApi/index.js";
export default {
  props: ["info", "type", "importAuditState", "importItem"],
  components: {mtDetail},
  data() {
    return {
      activeName: "first",
      list: [
        { title: "课程类型", text: "" },
        { title: "教学目的", text: "" },
        { title: "适用年级", text: "" },
        { title: "课程特点", text: "" },
        { title: "授课时间安排", text: "" },
        { title: "课程描述", text: "" },
      ],
      stateObj: {
        1: "申请审核",
        2: "审核通过",
        3: "审核不通过",
        4: "已下架",
      },
      table_1: [],
      table_2: [],
      detail: {
        info: {},
        show: false,
      },
      m_info: {},
      mtDetail: {
        info: {},
        show: false,
      },
      import_agreed: false,
      Userlist: JSON.parse(sessionStorage.getItem("userInfo")) || {},
    };
  },
  computed: {},
  watch: {
    info: {
      async handler(n, o) {
        let vm = this.info;
        if (!vm.resource) vm.resource = [];
        let str = `课时总数：${vm.periodTotal}课时<br/> 课时时长：${vm.periodTime}分钟<br/> 上课频率：${vm.frequency}次/周`;
        this.m_info = {};
        let p_str = "";
        if (vm.mid) {
          let m_res = await handleMaterialsDetail({ mid: vm.mid });
          if (m_res.result === "000000") {
            this.m_info = m_res.data;
          }
          if (this.m_info.price) {
            p_str = `${vm.price}　 材料价格　¥${
              this.m_info.price
            } 　总价格　 ¥${vm.price + this.m_info.price}`;
          } else {
            p_str = vm.price;
          }
        } else {
          p_str = vm.price;
        }

        if (this.type === "import") {
          this.list = [
            { title: "课程来源", text: vm.orgName },
            { title: "课程价格", text: p_str },
            { title: "课程类型", text: vm.typeName },
            { title: "教学目的", text: vm.teachAims },
            { title: "适用年级", text: util.getGrade(vm.scope) },
            { title: "课程特点", text: vm.feature },
            { title: "授课时间安排", text: str },
            { title: "课程介绍", text: vm.description },
          ];
          this.handleCourseauditrecordList();
        } else {
          this.list = [
            { title: "课程类型", text: vm.typeName },
            // { title: "教学目的", text: vm.teachAims },
            { title: "适用年级", text: util.getGrade(vm.scope) },
            // { title: "课程特点", text: vm.feature },
            { title: "授课时间安排", text: str },
            { title: "课程介绍", text: vm.description },
          ];
        }
        this.table_1 = vm.resource.filter((e) => e.source === "2");
        this.table_2 = vm.resource.filter((e) => e.source === "3");

        // 待审核状态下引入,滚动条到底
        if (this.type === "import" && this.importAuditState === "1") {
          this.scrollToBottom();
          this.import_agreed = false;
        }
      },
      deep: true,
    },
  },
  created() {this.info.resource=[]},
  methods: {
    dayjs,
    toDetail() {
      this.detail.show = false;
    },
    getFileType(ext) {
      return util.getFileType(ext);
    },
    toIndex() {
      this.$emit("to-index");
    },
    handleClick(tab, event) {
       if(tab.name=='material'){
          this.toMDetail()
      }
      this.activeName = tab.name;
    },
    previewFile(item) {
      window.open(item.previewUrl);
    },
    async toMDetail() {
      let params = {
        mid: this.info.mid,
      };
      var { result, data } = await handleMaterialsDetail(params);
      let res = await getAuditrecordList(params);
      if (result == "000000") {
        this.detail.info = data;
        if (res.result === "000000") {
          this.detail.info.operateList = res.data || [];
        }
        this.detail.show = true;
      } else {
        this.$message({
          type: "error",
          message: "获取信息失败",
        });
      }
    },
    // 获取课程审核列表
    async handleCourseauditrecordList() {
      console.log('获取审核列表---',this.info);
      let params = {
        cid: this.info.cid,
        orgId: this.info.orgId,
      };
      let res = await educationApi.getEducationCourseauditrecord(params);
      if (res.result === "000000") {
        this.detail.info.operateList = res.data || [];
      } else {
        this.$message({
          type: "error",
          message: "获取信息失败",
        });
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        var container = document.querySelector(".detail_box");
        document.querySelector(".detail_box").scrollTop =
          container.scrollHeight;
      });
    },
    async importFun() {
      let vm = this;
      let params = {
        cid: vm.importItem.cid,
        orgName: vm.importItem.source,
        orgId: vm.importItem.orgId,
      };
      let { result } = await schoolApi.schoolCourseImportcourse(params);
      if (result == "000000") {
        vm.$message({
          type: "success",
          message: "操作成功",
        });
        vm.$emit("to-index", "importSuccess");
      } else {
        vm.$message({
          type: "error",
          message: "操作失败",
        });
      }
    },
    async toMDetail() {
      let params = {
        mid: this.info.mid,
      };
      var { result, data } = await handleMaterialsDetail(params);
      if (result == "000000") {
        this.mtDetail.info = data;
        this.mtDetail.show = true;
      } else {
        this.$message({
          type: "error",
          message: "获取信息失败",
        });
      }
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.detail_box {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.detail {
  width: 100%;
  padding: 0px 30px 30px;
  .header {
    height: 60px;
    line-height: 48px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .span1 {
      font-family: "PingFang SC Bold";
      font-size: 20px;
      color: #000;
      margin-right: 30px;
    }
    .left,
    .right {
      width: 60px;
    }
    .left {
      cursor: pointer;
    }
  }
  .main {
    width: 100%;
    height: 100%;
    .main-title {
      display: flex;
      align-items: center;
      p {
        font-weight: bold;
        font-size: 14px;
        color: #181c26;
        margin-left: 10px;
      }
    }
    .main-li {
      margin-top: 20px;
      width: 100%;
      display: flex;
      // align-items: center;
      font-size: 14px;
      color: #888;
      p {
        width: 120px;
        text-align: right;
        margin-right: 20px;
      }
      span {
        width: calc(100% - 150px);
        word-wrap: break-word;
      }
    }
  }

  .table {
    width: 100%;
    margin-top: 30px;
    border: 1px solid #eee;
    .td-1 {
      width: 30%;
      height: 100%;
      float: left;
    }
    .td-2 {
      width: 70%;
      height: 100%;
      float: right;
    }
    .file {
      display: flex;
      align-items: center;
      justify-content: space-between;
      div {
        display: flex;
        align-items: center;
        img {
          margin-right: 20px;
        }
        span {
          width: 200px;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      a {
        font-size: 14px;
        line-height: 48px;
        color: #4991e1;
        margin-right: 20px;
      }
    }
    li {
      display: inline-block;
      width: 50%;
      height: 48px;
      text-align: center;
      font-size: 14px;
      line-height: 48px;
      color: #7a8da2;
      position: relative;
    }
    .table-header {
      width: 100%;
      height: 48px;
      background: #fafafa;
      border: 1px solid #eee;
      display: flex;
      div {
        height: 100%;
        text-align: center;
        font-size: 14px;
        line-height: 48px;
        color: #7a8da2;
      }
    }
  }
  .table_2_tr {
    width: 100%;
    height: 48px;
    font-size: 14px;
    line-height: 48px;
    color: #7a8da2;
    text-align: center;
  }

  .handle-item {
    width: 100%;
    height: 50px;
    margin-top: 20px;
    font-size: 14px;
    display: flex;
    align-items: flex-start;
    padding-left: 80px;
    position: relative;
    .line {
      position: absolute;
      width: 1px;
      height: calc(100% + 10px);
      background: #eeeeee;
      left: 90px;
      top: calc(50% - 5px);
    }
    .handle-title {
      width: 50%;
      margin-left: 15px;
      .text {
        color: #888;
      }
    }
    .handle-name {
      min-width: 120px;
      text-align: right;
    }
    .handle-time {
      margin-left: 20px;
      color: #888;
    }
  }

  .price-box {
    display: flex;
    align-items: center;
    margin-top: 30px;
    span {
      width: 80px;
      color: #888;
    }
    ::v-deep .el-input__inner {
      height: 32px;
    }
  }
}

.info_header {
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  .info_header_item {
    img {
      height: 80px;
      max-width: 500px;
    }
    div {
      margin: 15px;
    }
  }
}
.to_material {
  cursor: pointer;
  color: #4991e1;
}
::v-deep .el-tabs__nav {
  height: 45px !important;
  margin-top: 10px !important;
}
.video-class {
  max-width: 300px;
}

.import_footer {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
.import_checkbox {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
</style>
